/**
 * Icon Components
 * SVG icons used throughout the application
 */

export function ChevronIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M6 9l6 6 6-6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowLeftIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M15 19l-7-7 7-7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowRightIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M9 5l7 7-7 7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuIcon({ className = "", color = "currentColor" }) {
  return (
    <svg className={className} viewBox="0 0 24 16" aria-hidden="true">
      <path
        d="M2 1h20M2 8h20M2 15h20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CloseIcon({ className = "", color = "currentColor" }) {
  return (
    <svg className={className} viewBox="0 0 18 18" aria-hidden="true">
      <path
        d="M3 3l12 12m0-12L3 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CheckIcon({
  className = "",
  color = "var(--color-secondary)",
}) {
  return (
    /*<svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M16.667 5L7.5 14.167 3.333 10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>*/
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
    >
      <path
        d="M5.16782 10.3256C7.0031 6.8271 9.3206 4.02137 12.0543 1.9891C12.544 1.62587 12.6455 0.933258 12.2822 0.445033C11.9191 -0.0446546 11.2278 -0.144655 10.7397 0.217108C8.20447 2.10086 6.00602 4.57282 4.18404 7.5801C3.48847 6.48597 2.72821 5.52722 1.8856 4.68017C1.45472 4.24636 0.754749 4.24637 0.325362 4.67576C-0.106976 5.1051 -0.108451 5.8051 0.320949 6.23597C1.41944 7.34035 2.36499 8.67559 3.21055 10.3182C3.40024 10.6858 3.78405 10.9211 4.19139 10.9168C4.60167 10.9168 4.97812 10.6887 5.16782 10.3256Z"
        fill={color}
      />
    </svg>
  );
}

export function StarsIcon({ className = "", color = "#ff8d01" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 80 16"
      fill="none"
      aria-hidden="true"
    >
      {[0, 16, 32, 48, 64].map((x) => (
        <path
          key={x}
          d={`M${x + 8} 0l2.47 5.01 5.53.8-4 3.9.94 5.5L${x + 8} 12.76l-4.94 2.6.94-5.5-4-3.9 5.53-.8L${x + 8} 0z`}
          fill={color}
        />
      ))}
    </svg>
  );
}

export function VerifiedIcon({ className = "", color = "" }) {
  return (
    <svg className={className} width="17px" height="16px" viewBox="0 0 17 16">
      <g id="verified-white" stroke="none" fill="none" fillRule="nonzero">
        <path
          d="M8.5,0.667 L14.5,3.333 L14.5,7.333 C14.5,11.033 11.94,14.493 8.5,15.333 C5.06,14.493 2.5,11.033 2.5,7.333 L2.5,3.333 L8.5,0.667 Z M10.6188622,5.39792402 C10.5022487,5.38041174 10.3835783,5.41181473 10.2908896,5.48471331 C9.64803821,5.99113432 9.08117293,6.58717121 8.60762065,7.2546054 C8.2734265,7.72408128 8.03815384,8.22082745 7.81143655,8.70206699 L7.09706319,7.4615384 C6.97388834,7.24870145 6.70166841,7.17574268 6.48856253,7.29845166 L6.10143205,7.51982185 C5.88907275,7.64381593 5.8159022,7.91552414 5.9372759,8.12939193 L6.94734422,9.88110386 C7.14625656,10.2195757 7.48900605,10.4254392 7.84672744,10.4254392 C8.24776039,10.4131409 8.5760727,10.1848195 8.76001317,9.81586914 C8.84378446,9.64440529 8.92541693,9.47294144 9.00491058,9.30147759 C9.21986424,8.84323058 9.42198485,8.41118444 9.69468726,8.02833163 C10.085026,7.47918385 10.5368565,6.99847902 11.0715671,6.56750227 C11.2635282,6.41350562 11.3095133,6.13545611 11.167815,5.9381479 L10.9068762,5.57721824 C10.839688,5.48031036 10.7354758,5.4154363 10.6188622,5.39792402 Z"
          id="Combined-Shape"
          fill={color}
        ></path>
      </g>
    </svg>
  );
}

export function PlayIcon({ className = "", color = "white" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
    >
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}

// Social Media Icons
export function InstagramIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="5"
        stroke={color}
        strokeWidth="2"
      />
      <circle cx="12" cy="12" r="4" stroke={color} strokeWidth="2" />
      <circle cx="18" cy="6" r="1" fill={color} />
    </svg>
  );
}

export function TikTokIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
    >
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
    </svg>
  );
}

export function FacebookIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
    >
      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
    </svg>
  );
}

export function TwitterIcon({ className = "", color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default {
  ChevronIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  MenuIcon,
  CloseIcon,
  CheckIcon,
  StarsIcon,
  VerifiedIcon,
  PlayIcon,
  InstagramIcon,
  TikTokIcon,
  FacebookIcon,
  TwitterIcon,
};
